import { useState } from "react";
import { AnimatePresence, motion } from "framer-motion";
import { PlayCircle, X } from "lucide-react";

const VIDEO_URL = "https://video.wixstatic.com/video/d32254_82caa68501e640e6bab609c785cda365/480p/mp4/file.mp4";

export const VideoTutorial = () => {
  const [open, setOpen] = useState(false);
  return (
    <>
      <button
        data-testid="video-tutorial-btn"
        onClick={() => setOpen(true)}
        className="inline-flex items-center gap-2 text-sm font-semibold text-[#2E8A57] link-underline"
      >
        <PlayCircle className="w-5 h-5" /> Guarda il video tutorial
      </button>
      <AnimatePresence>
        {open && (
          <motion.div
            data-testid="video-modal"
            className="fixed inset-0 z-[80] bg-black/80 flex items-center justify-center p-4"
            initial={{ opacity: 0 }} animate={{ opacity: 1 }} exit={{ opacity: 0 }}
            onClick={() => setOpen(false)}
          >
            <motion.div
              className="relative w-full max-w-3xl rounded-2xl overflow-hidden bg-black"
              initial={{ scale: 0.92, y: 20 }} animate={{ scale: 1, y: 0 }} exit={{ scale: 0.92, y: 20 }}
              transition={{ duration: 0.35, ease: [0.22, 1, 0.36, 1] }}
              onClick={(e) => e.stopPropagation()}
            >
              <button
                data-testid="video-modal-close"
                onClick={() => setOpen(false)}
                className="absolute top-3 right-3 z-10 w-9 h-9 rounded-full bg-black/60 text-white flex items-center justify-center hover:bg-black/90 transition-colors"
              >
                <X className="w-4 h-4" />
              </button>
              <video src={VIDEO_URL} controls autoPlay playsInline className="w-full aspect-video" data-testid="tutorial-video" />
              <div className="px-5 py-3 bg-[#243329]">
                <p className="font-mono-accent text-[10px] uppercase tracking-[0.25em] text-[#7DC242]">Pronto in 5 minuti — video dal sito ufficiale</p>
              </div>
            </motion.div>
          </motion.div>
        )}
      </AnimatePresence>
    </>
  );
};
